import React, { useState, useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import { config } from "../../../config/config";
import { useUserAuthentication } from "../../../utils/utils";
import { useHistory } from "react-router-dom";
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import { ApprovalButton } from "../../../components/Approval/ApprovalButton";
import MainTemplateView from "./MainTemplateView";
import LayoutTopSideBottom from "../../../layouts/LayoutTopSideBottom/LayoutTopSideBottom";

let api = config.api.api_url;

function ProductMapping(props) {
  const {
    user,
    match,
    updateSourceInputs,
    updateAlert,
    source_data,
    user_detail,
  } = props;

  // STATES
  const [loading, setLoading] = useState(true);
  const [isApproval, setIsApproval] = useState(false);
  let history = useHistory();
  const URL = history?.location?.pathname;
  // const Use_Case_Name = URL.split("/").pop();
  const Use_Case_Name = source_data?.current_usecase_value || "product_mapping";
  const { login } = useUserAuthentication();

  const is_Approver = useMemo(() => {
    const Is_Role_Approver = user?.role && user?.role?.includes("AppApprover");
    const URL = history?.location?.pathname || [];
    const result = URL.split("/").pop();
    const is_Approver_For_This_Usecase =
      user?.approval_screens && user?.approval_screens?.includes(result);
    return Is_Role_Approver && is_Approver_For_This_Usecase;
  }, [user.role, user.approval_screens]);

  // FUNCTIONS
  async function getSources() {
    try {
      // code for initial data fetching
      const response = await fetch(
        api + `/product_mapping/getmetadata?usecase_name=${Use_Case_Name}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });

          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      const DATASETS =
        data?.data?.SOURCE?.map((item) => {
          return {
            label: item !== "Nielsen" ? item?.toUpperCase() : item,
            value: item,
          };
        }) ?? [];

      const Data = { ...data, dropdown: { ...data.data } };

      updateSourceInputs("data", Data);
      updateSourceInputs(
        "temp_edit_modal_column_list",
        data?.data?.edit_model_column_list || [],
      );
      updateSourceInputs(
        "temp_table_header_column_list",
        data?.data?.table_header_column_list || [],
      );
      updateSourceInputs("current_mapped_source", DATASETS);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setLoading(false);
    }
  }

  const clearReduxState = () => {
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("current_usecase", "");
    updateSourceInputs("current_usecase_list", []);
    updateSourceInputs("isNewLocalValue_logs", []);
    updateSourceInputs("isNewMappedValue_logs", []);
    updateSourceInputs("isNewDropdownLocalValue", false);
    updateSourceInputs("isNewDropdownMappedValue", false);
    updateSourceInputs("data", []);
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("current_bussines_unit", "");
    updateSourceInputs("current_dimension", {});
    updateSourceInputs("dimensions_list", []);
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_source_label", "");
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_cmu", "");
    updateSourceInputs("current_category", "");
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_template_filter_value", "");
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isFileUploaded", false);
    updateSourceInputs("isNewDataInserted", false);
    updateSourceInputs("current_bussines_unit_list", []);
    updateSourceInputs("current_mapped_source", []);
    updateSourceInputs("current_target_gold_layer_list", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("master_table_countries", []);
    updateSourceInputs("current_ssf_file_id", []);
    updateSourceInputs("current_template_ssf_file_id", []);
    updateSourceInputs("current_category_data", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_filters", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("download_sample_file", []);
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("current_columns", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
    updateSourceInputs("approvalData", []);
    updateSourceInputs("approvalTable_Header", []);
  };

  const getApprovalData = async () => {
    clearReduxState();
    setLoading(true);
    try {
      const params = new URLSearchParams({
        usecase_name: Use_Case_Name || "",
        user_name: user.mail || "",
      });
      const response = await fetch(
        api + `/approval/getapprovaldata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );
      // Check if response is OK before trying to parse it
      if (!response.ok) {
        throw new Error(`Unexpected error occured. Please try again later`);
      }

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      updateSourceInputs("approvalData", data.data);
      updateSourceInputs(
        "approvalTable_Header",
        data?.metadata?.table_headers || [],
      );
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await getSources();
    };
    fetchData();
  }, []);

  return (
    <LayoutTopSideBottom match={props.match}>
      {/* Breadcrumbs and Approval Option */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: is_Approver ? "10px" : "0px",
        }}
      >
        <Breadcrumbs match={match} />
        {is_Approver && (
          <ApprovalButton
            buttonText={
              source_data?.data?.dropdown?.approver_details?.button_text ||
              "Approval"
            }
            getApprovalData={getApprovalData}
            isApproval={isApproval}
            setIsApproval={setIsApproval}
            getSources={getSources}
            isTableDataLoading={
              !source_data.is_initial && source_data.is_table_loading
            }
            any_row_isEditing={source_data?.any_row_isEditing}
            sourceData={source_data}
          />
        )}
      </div>

      <MainTemplateView
        getSources={getSources}
        loading={loading}
        setLoading={setLoading}
        isApproval={isApproval}
        getApprovalData={getApprovalData}
        clearReduxState={clearReduxState}
      />
    </LayoutTopSideBottom>
  );
}

ProductMapping.propTypes = {
  user: PropTypes.object,
  source_data: PropTypes.object,
  updateAlert: PropTypes.func,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  source_data: state.source,
  user_detail: state.user_detail,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductMapping),
);
